import { render, staticRenderFns } from "./expired.vue?vue&type=template&id=371832db&"
import script from "./expired.vue?vue&type=script&lang=js&"
export * from "./expired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports